import gql from 'graphql-tag'
export default gql`
  query Controls {
    Controls @client {
      searchText
      showPasswordDialog
      email
      service
      newService
      showLinkDialog
      showForgotDialog
      showVerificationDialog
      routerFrom
      routerTo
      playing
      showAppBar
      targetType
      vimeoReconnect
      vimeoUserSearchText
      vimeoUserSelectedID
      vimeoVideoSearchText
      showVimeo
      showPersona
      selectedType
      refresh
      saveInProgress
      vimeoNavigateAfterAdd
      autoFilmLabelling
      createVerification
      showViLabelStats
    }
  }`
